import { simpleInit } from "./InitCompare";
import CompareLexus from "./components/lexus/CompareLexus";

export const init = simpleInit(CompareLexus);
